import { render, staticRenderFns } from "./PriceTable.vue?vue&type=template&id=2d869fcb&scoped=true&"
import script from "./PriceTable.vue?vue&type=script&lang=js&"
export * from "./PriceTable.vue?vue&type=script&lang=js&"
import style0 from "./PriceTable.vue?vue&type=style&index=0&id=2d869fcb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d869fcb",
  null
  
)

export default component.exports